import React, { useEffect, useState } from 'react';
import MobileSidebar from './MobileSidebar';
import { useHeaderContext } from '../Context/HeaderContext';


export default function MobileHeader({ auth, totalHistorico, totalGastado, porcentajeConsumido, handleLogout }) {
  const [openSearch, setOpenSearch] = useState(false);
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState([]);

  const {
    isCartOpen,
    setIsCartOpen,
    cartItems,
    removeFromCart,
    totalPrice,
    contarItems
  } = useHeaderContext();
  const user = auth?.user;

  useEffect(() => {
    // Si la búsqueda está vacía, limpiamos los resultados inmediatamente
    if (!searchQuery.trim()) {
      setResults([]);
      return;
    }

    // Configuración de Debounce (300ms) para no saturar el servidor
    const timer = setTimeout(async () => {
      try {
        const response = await axios.get('/buscar', {
          params: { query: searchQuery.trim() }
        });
        setResults(response.data);
      } catch (error) {
        console.error('Error al buscar productos:', error);
      }
    }, 300);

    // Cancelar el temporizador si el usuario sigue escribiendo
    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Manejo de error de imagen fallback
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/images/img/noimagen.jpg';
  };

  return (
    <>

      <div className="flex flex-row md:hidden px-[20px] items-center w-full relative">
        {/* Hamburguesa */}
        <div id="menu-burguer"
          className="md:hidden z-10 w-30 cursor-pointer clickSidebar"
          onClick={() => setIsSidebarOpen(true)}
        >
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M4.375 9.375H25.625C26.6608 9.375 27.5 8.53577 27.5 7.5C27.5 6.46423 26.6608 5.625 25.625 5.625H4.375C3.33923 5.625 2.5 6.46423 2.5 7.5C2.5 8.53577 3.33923 9.375 4.375 9.375Z"
                fill="black"
              />
              <path
                d="M25.625 13.125H4.375C3.33923 13.125 2.5 13.9642 2.5 15C2.5 16.0358 3.33923 16.875 4.375 16.875H25.625C26.6608 16.875 27.5 16.0358 27.5 15C27.5 13.9642 26.6608 13.125 25.625 13.125Z"
                fill="black"
              />
              <path
                d="M25.625 20.625H4.375C3.33923 20.625 2.5 21.4642 2.5 22.5C2.5 23.5358 3.33923 24.375 4.375 24.375H25.625C26.6608 24.375 27.5 23.5358 27.5 22.5C27.5 21.4642 26.6608 20.625 25.625 20.625Z"
                fill="black"
              />
            </svg>
          </div>
        </div>

        {/* Logo */}
        <div className='flex flex-row justify-between w-full'>
          <div className="flex md:hidden w-[140px] h-[48px] ml-[20px]">
            <a href="/" className="mt-1">
              <img src="/images/ux/headermobil.svg" alt="Header Mobile" />
            </a>
          </div>

          <div className="flex flex-row items-center ml-[13px] gap-4 justify-start">
            {/* Buscador */}
            <div className=" inline-flex">
              <div
                className="cursor-pointer flex items-center"
                aria-haspopup="true"
                aria-expanded={openSearch}
                onClick={() => setOpenSearch(!openSearch)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 25 25" fill="none">
                  <g clipPath="url(#clip0_105_118)">
                    <path
                      d="M24.6945 23.222L17.5852 16.1127C18.9623 14.4117 19.7915 12.2502 19.7915 9.89612C19.7915 4.43992 15.3519 0.000366211 9.8957 0.000366211C4.43951 0.000366211 0 4.43987 0 9.89607C0 15.3523 4.43956 19.7918 9.89575 19.7918C12.2499 19.7918 14.4113 18.9627 16.1123 17.5856L23.2216 24.6949C23.4248 24.898 23.6914 25.0001 23.9581 25.0001C24.2248 25.0001 24.4915 24.898 24.6946 24.6949C25.1019 24.2876 25.1019 23.6293 24.6945 23.222ZM9.89575 17.7085C5.58745 17.7085 2.08333 14.2044 2.08333 9.89607C2.08333 5.58776 5.58745 2.08365 9.89575 2.08365C14.2041 2.08365 17.7082 5.58776 17.7082 9.89607C17.7082 14.2044 14.204 17.7085 9.89575 17.7085Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_105_118">
                      <rect width="25" height="25" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              {openSearch && (
                <div className="w-96 h-[237px] absolute top-[53px] left-1/2 -translate-x-1/2 bg-white rounded-b-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.10)]">
                  <div className="flex flex-row items-center justify-between border-b-[0.5px] border-[#E3E3E3] h-[52px] w-full px-[24px]">
                    <input
                      type="text"
                      placeholder="¿Qué buscas?"
                      id="buscarproducto"
                      className="h-[31px] outline-none border-none focus:outline-none focus:ring-0"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <div className="cursor-pointer" onClick={() => setOpenSearch(false)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.96049 18.596C4.53745 19.0191 4.53751 19.705 4.96062 20.1281C5.38373 20.5511 6.06965 20.5511 6.49268 20.1279L12.5434 14.0762L18.5945 20.1274C19.0176 20.5504 19.7035 20.5504 20.1266 20.1274C20.5496 19.7044 20.5496 19.0184 20.1266 18.5954L14.0753 12.5441L20.1262 6.49215C20.5491 6.06905 20.5491 5.38312 20.1259 4.96009C19.7029 4.53705 19.0169 4.53712 18.5939 4.96022L12.5431 11.012L6.49194 4.96074C6.06888 4.53768 5.38295 4.53768 4.95988 4.96074C4.53681 5.38382 4.53681 6.06974 4.95988 6.49282L11.0113 12.5442L4.96049 18.596Z"
                          fill="#292929"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="flex flex-col h-[184px] w-full border-b-[0.5px] border-[#E3E3E3] pt-[11px] overflow-y-auto font-dm_sans text-[16px]"
                    id="resultados2"
                  >
                    {/* Renderizado declarativo de los resultados */}
                    {results.length > 0 && (
                      <div className="flex flex-col h-[184px] w-full border-b-[0.5px] border-[#E3E3E3] pt-[11px] overflow-y-auto font-dm_sans text-[16px]">
                        {results.map((result) => {
                          const price = Number(result.precio) || 0;
                          const discount = Number(result.descuento) || 0;
                          const coverImage = result.images?.find((img) => img.caratula === 1)?.name_imagen || '';

                          return (
                            <a key={result.slug || result.id} href={`/producto/${result.slug}`}>
                              <div className="w-full flex gap-2 flex-row py-3 px-5 hover:bg-slate-200">
                                <div className="w-[10%]">
                                  <img
                                    className="w-14 rounded-md"
                                    src={`/${coverImage}`}
                                    onError={handleImageError}
                                    alt={result.producto}
                                  />
                                </div>
                                <div className="flex flex-col justify-center w-[60%]">
                                  <h2 className="text-left">{result.producto}</h2>
                                </div>
                                <div className="flex flex-col justify-center w-[30%]">
                                  <p className="text-right w-max">
                                    S/ {discount > 0 ? discount.toFixed(2) : price.toFixed(2)}
                                  </p>
                                  {discount > 0 && (
                                    <p className="text-text12 text-right line-through text-slate-500 w-max">
                                      S/ {price.toFixed(2)}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </a>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Sección Usuario */}
            <div className="cursor-pointer">
              {!user ? (
                <a className="flex" href="/login">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" viewBox="0 0 23 25" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.0623 9.83333C13.0989 9.83333 14.7498 8.18238 14.7498 6.14583C14.7498 4.10929 13.0989 2.45833 11.0623 2.45833C9.02573 2.45833 7.37484 4.10929 7.37484 6.14583C7.37484 8.18238 9.02573 9.83333 11.0623 9.83333ZM11.0623 12.2917C14.4566 12.2917 17.2082 9.54008 17.2082 6.14583C17.2082 2.75159 14.4566 0 11.0623 0C7.66809 0 4.9165 2.75159 4.9165 6.14583C4.9165 9.54008 7.66809 12.2917 11.0623 12.2917Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.375 17.2083C4.6596 17.2083 2.45833 19.4096 2.45833 22.125V23.3542C2.45833 24.033 1.90801 24.5833 1.22917 24.5833C0.550323 24.5833 0 24.033 0 23.3542V22.125C0 18.0519 3.3019 14.75 7.375 14.75H14.75C18.8231 14.75 22.125 18.0519 22.125 22.125V23.3542C22.125 24.033 21.5747 24.5833 20.8958 24.5833C20.217 24.5833 19.6667 24.033 19.6667 23.3542V22.125C19.6667 19.4096 17.4654 17.2083 14.75 17.2083H7.375Z"
                      fill="black"
                    />
                  </svg>
                </a>
              ) : (
                <div className="relative flex">
                  <button
                    className="py-5 inline-flex justify-center items-center group"

                    onClick={() => setOpenUserMenu(!openUserMenu)}
                  >
                    <div className="flex items-center truncate">
                      <div
                        className="relative w-9 h-9 rounded-full overflow-hidden"
                        style={{
                          backgroundImage: "url('/images/ux/logged.png')",
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        }}
                      >
                        <img
                          loading="lazy"
                          className="w-full p-[6px] rounded-full"
                          src={user.profile_photo_url}
                          alt={user.name}
                        />
                      </div>
                    </div>
                  </button>

                  {openUserMenu && (
                    <div className="w-[calc(100vw-20px)] shadow-lg  absolute top-[90px] -right-12 bg-white rounded-[10px] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.10)]">
                      {/* ── 1. HEADER USUARIO ── */}
                      <div
                        className="relative overflow-hidden flex items-center gap-[14px] px-5 py-5 border-b border-[#eee0ce]"
                        style={{ background: "linear-gradient(135deg,#fbf3e7 0%,#f3e4cc 100%)" }}
                      >
                        {/* Círculos decorativos */}
                        <div className="absolute -top-7 -right-4 w-[90px] h-[90px] rounded-full bg-[#ff8555] opacity-[0.07] pointer-events-none" />
                        <div className="absolute -bottom-3 right-7 w-14 h-14 rounded-full bg-[#2f8f5b] opacity-[0.07] pointer-events-none" />

                        {/* Avatar */}
                        <div className="relative flex-shrink-0">
                          <div
                            className="w-12 h-12 rounded-full flex items-center justify-center font-black text-lg text-white overflow-hidden"
                            style={{ background: "linear-gradient(135deg,#ff8555,#f06b35)", boxShadow: "0 4px 12px rgba(255,133,85,.35)" }}
                          >
                            <img
                              className="w-full h-full object-cover"
                              src={user.profile_photo_url}
                              alt={user.name}
                              onError={e => { e.target.style.display = "none"; }}
                            />
                          </div>
                          <div className="absolute -bottom-px -right-px w-[13px] h-[13px] bg-[#2f8f5b] rounded-full border-2 border-[#fbf3e7]" />
                        </div>

                        {/* Datos */}
                        <div className="min-w-0 flex-1">
                          <p className="font-bold text-[15px] text-[#171614] truncate leading-tight font-plus_jakarta">
                            {user.name}
                          </p>
                          <p className="text-[12px] text-[#a89a8c] mt-[3px] truncate font-plus_jakarta">
                            {user.email}
                          </p>
                        </div>
                      </div>

                      {/* ── 2. TARJETA FLORIPUNTOS ── */}
                      <div
                        className="mx-4 mt-4 rounded-2xl overflow-hidden relative"
                        style={{ background: "linear-gradient(135deg,#2f8f5b 0%,#1e6b43 100%)" }}
                      >
                        {/* Círculos deco */}
                        <div className="absolute -top-9 -right-7 w-[120px] h-[120px] rounded-full border-[28px] border-white opacity-[0.07] pointer-events-none" />
                        <div className="absolute -bottom-6 -left-4 w-20 h-20 rounded-full border-[20px] border-white opacity-[0.05] pointer-events-none" />

                        <div className="relative z-10 px-[18px] pt-[18px] pb-4">

                          {/* Header tarjeta */}
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center gap-2">
                              <div className="w-[26px] h-[26px] rounded-full bg-white/[0.15] flex items-center justify-center">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                  stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                              </div>
                              <span className="text-[11.5px] font-bold text-white/[0.85] uppercase tracking-[0.04em] font-plus_jakarta">
                                Floripuntos
                              </span>
                            </div>
                            <a
                              href="/micuenta/puntos"
                              className="text-[11.5px] font-semibold text-white/[0.65] border-b border-white/[0.3] pb-px no-underline hover:text-white transition-colors font-plus_jakarta"
                            >
                              Ver historial →
                            </a>
                          </div>

                          {/* Número grande — puntos disponibles */}
                          <div className="flex items-end mb-1">
                            <span
                              className="font-bold text-[52px] text-white leading-none tracking-tight"
                              style={{ fontFamily: "'Cormorant Garamond', serif" }}
                            >
                              {totalHistorico - totalGastado}
                            </span>
                            <span className="text-[14px] font-bold text-white/[0.70] mb-2 ml-1.5 font-plus_jakarta">
                              pts
                            </span>
                          </div>
                          <p className="text-[12px] text-white/[0.65] mb-3 font-plus_jakarta">
                            disponibles para canjear
                          </p>

                          {/* Barra de progreso */}
                          <div className="w-full bg-white/[0.15] rounded-full h-1.5 mb-2 overflow-hidden">
                            <div
                              className="h-1.5 rounded-full transition-all duration-500"
                              style={{
                                width: `${porcentajeConsumido}%`,
                                background: "linear-gradient(90deg,#ff8555,#f0c98a)",
                              }}
                            />
                          </div>

                          {/* Pills de stats */}
                          <div className="flex gap-2">
                            <div className="bg-white/[0.12] rounded-full px-3 py-[5px] flex items-center gap-[5px]">
                              <div className="w-[7px] h-[7px] rounded-full bg-[#ff8555] flex-shrink-0" />
                              <span className="text-[11.5px] font-semibold text-white/[0.80] font-plus_jakarta">
                                {totalGastado} usados
                              </span>
                            </div>
                            <div className="bg-white/[0.12] rounded-full px-3 py-[5px] flex items-center gap-[5px]">
                              <div className="w-[7px] h-[7px] rounded-full bg-white/[0.50] flex-shrink-0" />
                              <span className="text-[11.5px] font-semibold text-white/[0.80] font-plus_jakarta">
                                {totalHistorico} totales
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>

                      {/* ── CTA CANJEAR ── */}
                      <div className="mx-4 mt-3">
                        <a
                          href="/complementos"
                          className="w-full bg-[#fff6f1] border border-[#ffd2bd] rounded-xl py-[11px] flex items-center justify-center gap-2 text-[13.5px] font-bold text-[#d9602f] hover:bg-[#ffe8d8] transition-colors no-underline font-plus_jakarta"
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                            stroke="#ff8555" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 12V22H4V12" />
                            <path d="M22 7H2v5h20V7z" />
                            <path d="M12 22V7" />
                            <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z" />
                            <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" />
                          </svg>
                          Canjear floripuntos
                        </a>
                      </div>

                      {/* ── 3. LINKS ── */}
                      <div className="py-2 mt-1">

                        {/* Mi cuenta / Dashboard Admin */}
                        {console.log(auth.role)}
                        {auth.role?.includes('Admin') ? (
                          <a
                            href="/admin/sales"
                            className="group flex items-center gap-3 px-5 py-[11px] hover:bg-[#fbf3e7] transition-colors no-underline"
                          >
                            <div className="w-[34px] h-[34px] rounded-[10px] bg-[#f5efe8] group-hover:bg-[#ffe8d8] flex items-center justify-center flex-shrink-0 transition-colors">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="#a89a8c" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                                className="group-hover:stroke-[#ff8555] transition-colors">
                                <rect x="3" y="3" width="7" height="7" />
                                <rect x="14" y="3" width="7" height="7" />
                                <rect x="14" y="14" width="7" height="7" />
                                <rect x="3" y="14" width="7" height="7" />
                              </svg>
                            </div>
                            <span className="flex-1 text-[14px] font-semibold text-[#2b211c] group-hover:text-[#ff8555] transition-colors font-plus_jakarta">
                              Dashboard Admin
                            </span>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                              stroke="#d0c4b8" strokeWidth="2"
                              className="group-hover:stroke-[#ff8555] transition-colors">
                              <path d="M9 18l6-6-6-6" />
                            </svg>
                          </a>
                        ) : (
                          <>
                            <a
                              href="/micuenta"
                              className="group flex items-center gap-3 px-5 py-[11px] hover:bg-[#fbf3e7] transition-colors no-underline"
                            >
                              <div className="w-[34px] h-[34px] rounded-[10px] bg-[#f5efe8] group-hover:bg-[#ffe8d8] flex items-center justify-center flex-shrink-0 transition-colors">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                  stroke="#a89a8c" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                                  className="group-hover:stroke-[#ff8555] transition-colors">
                                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                                  <circle cx="12" cy="7" r="4" />
                                </svg>
                              </div>
                              <span className="flex-1 text-[14px] font-semibold text-[#2b211c] group-hover:text-[#ff8555] transition-colors font-plus_jakarta">
                                Mi cuenta
                              </span>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="#d0c4b8" strokeWidth="2"
                                className="group-hover:stroke-[#ff8555] transition-colors">
                                <path d="M9 18l6-6-6-6" />
                              </svg>
                            </a>

                            {/* Mis pedidos */}
                            <a
                              href="/micuenta/historial"
                              className="group flex items-center gap-3 px-5 py-[11px] hover:bg-[#fbf3e7] transition-colors no-underline"
                            >
                              <div className="w-[34px] h-[34px] rounded-[10px] bg-[#f5efe8] group-hover:bg-[#ffe8d8] flex items-center justify-center flex-shrink-0 transition-colors">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                  stroke="#a89a8c" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                                  className="group-hover:stroke-[#ff8555] transition-colors">
                                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
                                  <line x1="3" y1="6" x2="21" y2="6" />
                                  <path d="M16 10a4 4 0 01-8 0" />
                                </svg>
                              </div>
                              <span className="flex-1 text-[14px] font-semibold text-[#2b211c] group-hover:text-[#ff8555] transition-colors font-plus_jakarta">
                                Mis pedidos
                              </span>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="#d0c4b8" strokeWidth="2"
                                className="group-hover:stroke-[#ff8555] transition-colors">
                                <path d="M9 18l6-6-6-6" />
                              </svg>
                            </a>

                          </>

                        )}



                      </div>

                      {/* ── 4. LOGOUT ── */}
                      <div className="border-t border-[#f0e8de]">
                        <button
                          onClick={handleLogout}
                          className="group w-full flex items-center gap-3 px-5 py-[11px] hover:bg-[#fff0f0] transition-colors"
                        >
                          <div className="w-[34px] h-[34px] rounded-[10px] bg-[#f5efe8] group-hover:bg-[#fde8e8] flex items-center justify-center flex-shrink-0 transition-colors">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                              stroke="#a89a8c" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                              className="group-hover:stroke-[#e05555] transition-colors">
                              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                              <polyline points="16 17 21 12 16 7" />
                              <line x1="21" y1="12" x2="9" y2="12" />
                            </svg>
                          </div>
                          <span className="text-[14px] font-semibold text-[#a89a8c] group-hover:text-[#e05555] transition-colors font-plus_jakarta">
                            Cerrar sesión
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Carrito */}
            <div id="open-cart"

              onClick={() => setIsCartOpen(true)}
              className="cursor-pointer relative">
              <span
                id="itemsCount"
                className="bg-[#FF8555] h-6 w-6 text-xs font-medium text-white text-center px-[7px] py-[2px] rounded-full absolute left-[5px] bottom-[12px] ml-3"
                style={{ zIndex: 10 }}
              >
                {contarItems}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 31 25" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.3609 8.50475C29.4119 8.19734 29.324 7.88284 29.1229 7.64484C28.9203 7.40825 28.6242 7.27084 28.3125 7.27084H2.81255C2.50088 7.27084 2.2048 7.40825 2.00221 7.64484C1.80105 7.88284 1.71321 8.19734 1.76421 8.50475C1.76421 8.50475 3.21205 17.3504 3.92463 21.7123C4.23346 23.5965 5.86121 24.9792 7.76946 24.9792H23.3556C25.2639 24.9792 26.8916 23.5965 27.2005 21.7123L29.3609 8.50475ZM27.0616 9.39584L25.1024 21.3695C24.9621 22.2252 24.2226 22.8542 23.3556 22.8542C19.43 22.8542 11.695 22.8542 7.76946 22.8542C6.90246 22.8542 6.16296 22.2252 6.02271 21.3695L4.06346 9.39584H27.0616Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.9734 7.7865L20.7234 0.703168C20.4216 0.200251 19.7685 0.0373343 19.2656 0.339084C18.7627 0.640834 18.5998 1.29392 18.9015 1.79683L23.1515 8.88017C23.4533 9.38308 24.1064 9.546 24.6093 9.24425C25.1122 8.9425 25.2751 8.28942 24.9734 7.7865Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.97337 8.88017L12.2234 1.79683C12.5251 1.29392 12.3622 0.640834 11.8593 0.339084C11.3564 0.0373343 10.7033 0.200251 10.4015 0.703168L6.15154 7.7865C5.84979 8.28942 6.01271 8.9425 6.51562 9.24425C7.01854 9.546 7.67162 9.38308 7.97337 8.88017Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.5 13.2917V18.9583C14.5 19.5448 14.976 20.0208 15.5625 20.0208C16.149 20.0208 16.625 19.5448 16.625 18.9583V13.2917C16.625 12.7052 16.149 12.2292 15.5625 12.2292C14.976 12.2292 14.5 12.7052 14.5 13.2917Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.8335 13.2917V18.9583C8.8335 19.5448 9.3095 20.0208 9.896 20.0208C10.4825 20.0208 10.9585 19.5448 10.9585 18.9583V13.2917C10.9585 12.7052 10.4825 12.2292 9.896 12.2292C9.3095 12.2292 8.8335 12.7052 8.8335 13.2917Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.167 13.2917V18.9583C20.167 19.5448 20.643 20.0208 21.2295 20.0208C21.816 20.0208 22.292 19.5448 22.292 18.9583V13.2917C22.292 12.7052 21.816 12.2292 21.2295 12.2292C20.643 12.2292 20.167 12.7052 20.167 13.2917Z"
                  fill="black"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.7293 7.27084H1.396C0.809496 7.27084 0.333496 7.74684 0.333496 8.33334C0.333496 8.91984 0.809496 9.39584 1.396 9.39584H29.7293C30.3158 9.39584 30.7918 8.91984 30.7918 8.33334C30.7918 7.74684 30.3158 7.27084 29.7293 7.27084Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>

        </div>

      </div>


      <MobileSidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}

        user={user}
      />
    </>

  );
}